'use client';

import { NextIntlClientProvider, useTranslations } from 'next-intl';
import ReactMarkdown from 'react-markdown';
import type { InterviewMessages } from '@/i18n/interviewLocale';

function NotOpenContent({ message }: { message?: string }) {
  const t = useTranslations('notOpen');
  return (
    <div className="flex h-full flex-col items-center justify-center">
      {/* <img src="/brand/logo.svg" alt="Corvus" className="w-[200px]" /> */}
      {/* Lists sit inline-block so they center as a unit; without it the
          markers hang far from the text in the centered column. */}
      <div className="prose prose-zinc prose-p:my-2 prose-ul:my-2 prose-li:my-0 prose-ul:inline-block prose-ul:text-left prose-ol:inline-block prose-ol:text-left px-6 pt-4 text-center text-foreground">
        <ReactMarkdown>{message || t('message')}</ReactMarkdown>
      </div>
    </div>
  );
}

export default function NotOpen({
  locale,
  messages,
  message
}: {
  locale: string;
  messages: InterviewMessages;
  /** Markdown shown in place of the localized `notOpen` default. */
  message?: string;
}) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <NotOpenContent message={message} />
    </NextIntlClientProvider>
  );
}
